/**
 * Reglamento de la Grada de Animación (SD Compostela).
 *
 * El reglamento se muestra cuando el abonado elige la región de la grada de
 * animación, tanto si llega por la URL (`?region_id=11513`) como si la marca
 * en el mapa de asientos.
 *
 * El identificador llega de la API con nombres distintos según por dónde
 * venga: `id` en el mapa principal, `region_id` en las anexas y `zona_id` en
 * el payload de la plaza. Por eso se compara contra los tres.
 */

export const REGION_ID_GRADA_ANIMACION = 11513;

/**
 * ¿La región indicada es la grada de animación?
 *
 * @param {number|string|null|undefined} regionId identificador suelto (query o id de zona)
 * @returns {boolean}
 */
export function esRegionGradaAnimacion(regionId) {
    if (regionId === null || regionId === undefined || regionId === '') {
        return false;
    }

    return Number(regionId) === REGION_ID_GRADA_ANIMACION;
}

/**
 * ¿Esta zona es la grada de animación? Tolera las tres claves con las que la
 * API identifica la misma región.
 *
 * @param {object|null|undefined} zona
 * @returns {boolean}
 */
export function zonaEsGradaAnimacion(zona) {
    if (!zona || typeof zona !== 'object') {
        return false;
    }

    return [zona.id, zona.region_id, zona.zona_id].some(esRegionGradaAnimacion);
}
